import React from "react";
import { LOADING_COPY } from "@/constants/loading.constants";

export const LoadingScreen = () => {
	return (
		<div className="fixed inset-0 flex flex-col items-center justify-center bg-mgt-black">
			<div className="relative">
				<div className="w-64 h-64 animate-spin-slow">
					<svg
						viewBox="0 0 100 100"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="w-full h-full"
					>
						<circle
							cx="50"
							cy="50"
							r="45"
							stroke="url(#gradientGlow)"
							strokeWidth="10"
							fill="transparent"
						/>
						<defs>
							<linearGradient
								id="gradientGlow"
								x1="0%"
								y1="0%"
								x2="100%"
								y2="100%"
							>
								<stop offset="0%" stopColor="#EEA136" />
								<stop offset="100%" stopColor="#36C47D" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 animate-fade-in">
					<svg
						viewBox="0 0 200 200"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="w-full h-full"
					>
						<circle
							cx="100"
							cy="100"
							r="90"
							stroke="#36C47D"
							strokeWidth="4"
							fill="transparent"
						/>
						<circle
							cx="100"
							cy="100"
							r="70"
							stroke="#EEA136"
							strokeWidth="4"
							fill="transparent"
						/>
						<line
							x1="100"
							y1="20"
							x2="100"
							y2="180"
							stroke="#FFF1E9"
							strokeWidth="2"
						/>
						<line
							x1="20"
							y1="100"
							x2="180"
							y2="100"
							stroke="#FFF1E9"
							strokeWidth="2"
						/>
						<circle cx="100" cy="20" r="5" fill="#EEA136" />
						<circle cx="100" cy="180" r="5" fill="#36C47D" />
						<circle cx="20" cy="100" r="5" fill="#E05E5C" />
						<circle cx="180" cy="100" r="5" fill="#918884" />
					</svg>
				</div>

				<div className="absolute top-1/4 left-1/4 w-4 h-4 bg-mgt-yellow rounded-full animate-bounce"></div>
				<div className="absolute top-1/3 right-1/3 w-3 h-3 bg-mgt-green rounded-full animate-pulse"></div>
				<div className="absolute bottom-1/4 left-1/3 w-5 h-5 bg-mgt-red rounded-full animate-spin-slow"></div>
			</div>

			<div className="mt-8">
				<p className="text-xl font-bold text-white animate-pulse">
					{LOADING_COPY.primary}
				</p>
			</div>
		</div>
	);
};

export default LoadingScreen;
